import { Agency } from '@app/models';
import { Action } from '@ngrx/store';

export enum AgencyDisplaySettingsActionTypes {
  UpdateAgencyDisplaySettings = '[AgencyDisplaySettings] Update Agency Display Settings'
}

export class UpdateAgencyDisplaySettings implements Action {
  readonly type = AgencyDisplaySettingsActionTypes.UpdateAgencyDisplaySettings;

  constructor(public  payload: { agency: Agency }) {
  }
}

export type AgencyDisplaySettingsActions =
  | UpdateAgencyDisplaySettings;
